import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * RequireAuth — sessions are for registered, signed-in people only.
 *
 * Wraps a route so an anonymous visitor is sent to sign-in with a redirect back
 * to where they were headed. Waits for the auth check to settle first, so a
 * signed-in visitor reloading the page is never bounced out.
 */
export default function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <div
          className="h-6 w-6 animate-spin rounded-full border-2 border-transparent"
          style={{ borderTopColor: "hsl(var(--marigold))" }}
          aria-label="Loading"
        />
      </div>
    );
  }

  if (!user) {
    const target = location.pathname + location.search;
    return <Navigate to={`/auth?redirect=${encodeURIComponent(target)}`} replace />;
  }

  return <>{children}</>;
}
